var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "agent-status-item-list" } },
    [
      _c("base-sortable-list", {
        staticClass: "agent-status-item-list",
        attrs: {
          list: _vm.statusOptions,
          "is-disabled": _vm.isDisabled,
          "is-scrollable": false,
          handle: "[data-button='drag-start']",
        },
        on: {
          update: function ($event) {
            return _vm.$emit("items-order-change", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function (ref) {
              var item = ref.props
              return [
                _c(
                  "div",
                  { staticClass: "option" },
                  [
                    _c("or-radio", {
                      attrs: {
                        "model-value": _vm.defaultStatusKey,
                        value: item.key,
                        disabled: _vm.isDisabled,
                      },
                      on: {
                        "update:modelValue": function ($event) {
                          return _vm.$emit("default-key-change", item.key)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("agent-status-item", {
                      attrs: {
                        item: item,
                        "is-active": item.key === _vm.targetKey,
                        "is-disabled": _vm.isDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("item-click", item.key)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }